export default __webpack_public_path__ + "static/media/pl4.4e141fe5.png";